import { rem } from 'polished';
import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

import { FatalAttraction } from '@vpr/tracking';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { translate } from '@vimeo/i18n-runtime';
import { Link } from '@vimeo/iris/typography';
import { ViewerContext } from '@vimeo/viewer';

interface Props {
  ownerId: number;
  userRole: string;
  hrefColor?: string;
}

const DEFAULT_HREF_COLOR = theme.colors.white as string;

const TeamMenuWrapper = styled.div`
  @media only screen and (max-width: 767px) {
    display: none;
  }
  display: inline-block;
  font-size: ${rem(16)};
`;

const TeamMenuListItem = styled.div`
  display: inline-block;
  margin-right: 20px;
  cursor: pointer;
  color: white;
`;

const StyledLink = styled(Link)<{ hrefColor: string }>`
  white-space: nowrap;
  color: ${(props) => props.hrefColor};
  &:hover,
  &:link,
  &:active,
  &:visited {
    color: ${(props) => props.hrefColor} !important;
  }
  &:after {
    display: none;
  }
`;

const TeamMenu = ({ ownerId, userRole, hrefColor }: Props) => {
  const curUser = useContext(ViewerContext);

  hrefColor = hrefColor || DEFAULT_HREF_COLOR;

  function track() {
    FatalAttraction.trackClick({
      container: 'team_home_page',
      component: 'manage_videos_link',
      keyword: 'click_managed_videos_' + userRole.toLowerCase(),
    });
  }

  function switchTeams() {
    return fetch('/manage/videos?action=SWITCH_TEAMS', {
      body: JSON.stringify({
        team_owner_id: ownerId,
        token: curUser?.xsrft,
      }),
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
    });
  }

  function redirect() {
    window.location.href = '/manage/videos';
  }

  return (
    <TeamMenuWrapper>
      <TeamMenuListItem>
        <StyledLink
          hrefColor={hrefColor}
          href="/manage/videos"
          onClick={(event) => {
            event.preventDefault();
            track();
            switchTeams().then(redirect);
          }}
        >
          {translate('Manage videos')}
        </StyledLink>
      </TeamMenuListItem>
    </TeamMenuWrapper>
  );
};

export default TeamMenu;
